function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.995 4.9925L3.405 4.9925L6.695 1.7025C7.085 1.3125 7.085 0.6825 6.695 0.2925C6.305 -0.0975 5.675 -0.0975 5.285 0.2925L0.285 5.2925C0.285 5.2925 0.275 5.3025 0.275 5.3125C0.195 5.3925 0.115 5.4925 0.075 5.6125C-0.025 5.8525 -0.025 6.1325 0.075 6.3825C0.125 6.4925 0.195 6.6025 0.285 6.6925C0.285 6.6925 0.285 6.7025 0.295 6.7025L5.295 11.7025C5.685 12.0925 6.315 12.0925 6.705 11.7025C7.095 11.3125 7.095 10.6825 6.705 10.2925L3.405 6.9925L14.995 6.9925C15.545 6.9925 15.995 6.5425 15.995 5.9925C15.995 5.4425 15.545 4.9925 14.995 4.9925Z",
  fill: "#444444"
});

function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.27dda21c.svg";
export { ForwardRef as ReactComponent };